import React from 'react';
import IconUwBasket from './icon-basket-uw';
import IconCalendar from './icon-calendar';
import IconCheck from './icon-check';
import IconCheckmark from './icon-checkmark';
import IconGopCart from './icon-gop-cart';
import IconGopChat from './icon-gop-chat';
import IconGopFb from './icon-gop-facebook';
import IconGopFourteenDays from './icon-gop-fourteen-days';
import IconGopInstagram from './icon-gop-instagram';
import IconGopLinkedin from './icon-gop-linkedin';
import IconGopLocation from './icon-gop-location';
import IconGopPintrest from './icon-gop-pinterest';
import IconGopSample from './icon-gop-sample';
import IconGopShiping from './icon-gop-shipping';
import IconHome from './icon-home';
import IconMail from './icon-mail';
import IconMenu from './icon-menu';
import IconPhone from './icon-phone';
import IconUwSearch from './icon-search-uw';
import IconSectionN from './icon-section-n';
import IconSectionO from './icon-section-o';
import IconSectionP from './icon-section-p';
import IconSectionQ from './icon-section-q';
import IconSectionR from './icon-section-r';
import IconSectionU from './icon-section-u';
import IconSectionY from './icon-section-y';
import IconStar from './icon-star';
import IconTallArrow from './icon-tallarrow';
import IconTbPhone from './icon-tbphone';
import IconWarning from './icon-warning';

export default {
  'icon-home': <IconHome />,
  'icon-menu': <IconMenu />,
  'icon-mail': <IconMail />,
  'icon-star': <IconStar />,
  'icon-tbphone': <IconTbPhone />,
  'icon-phone': <IconPhone />,
  'icon-section-n': <IconSectionN />,
  'icon-section-o': <IconSectionO />,
  'icon-section-p': <IconSectionP />,
  'icon-section-q': <IconSectionQ />,
  'icon-section-r': <IconSectionR />,
  'icon-section-u': <IconSectionU />,
  'icon-section-y': <IconSectionY />,
  'icon-checkmark': <IconCheckmark />,
  'icon-tall-arrow': <IconTallArrow />,
  'icon-basket-uw': <IconUwBasket />,
  'icon-search-uw': <IconUwSearch />,
  'icon-gop-cart': <IconGopCart />,
  'icon-gop-chat': <IconGopChat />,
  'icon-gop-location': <IconGopLocation />,
  'icon-check': <IconCheck />,
  'icon-warning': <IconWarning />,
  'icon-calendar': <IconCalendar />,
  'icon-gop-shipping': <IconGopShiping />,
  'icon-gop-sample': <IconGopSample />,
  'icon-gop-fourteen-days': <IconGopFourteenDays />,
  'icon-gop-facebook': <IconGopFb />,
  'icon-gop-linkedin': <IconGopLinkedin />,
  'icon-gop-instagram': <IconGopInstagram />,
  'icon-gop-pinterest': <IconGopPintrest />
};
